import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1321e934"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_22 = { class: "col-lg-8 fv-row" }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "row mb-6" }
const _hoisted_36 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_37 = { class: "col-lg-8 fv-row" }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_40 = { class: "col-lg-8 fv-row" }
const _hoisted_41 = { class: "row mb-6" }
const _hoisted_42 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_43 = { class: "col-lg-8 fv-row" }
const _hoisted_44 = { class: "fv-plugins-message-container" }
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = { class: "row mb-6" }
const _hoisted_47 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_48 = { class: "required" }
const _hoisted_49 = { class: "col-lg-8 fv-row" }
const _hoisted_50 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_56 = { class: "col-lg-8 fv-row" }
const _hoisted_57 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "row mb-6" }
const _hoisted_60 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_61 = { class: "required" }
const _hoisted_62 = { class: "col-lg-8 fv-row" }
const _hoisted_63 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "fv-plugins-message-container" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = { class: "row mb-6" }
const _hoisted_68 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_69 = { class: "required" }
const _hoisted_70 = { class: "col-lg-8 fv-row" }
const _hoisted_71 = { class: "fv-plugins-message-container" }
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = { class: "row mb-6" }
const _hoisted_74 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_75 = { class: "required" }
const _hoisted_76 = { class: "col-lg-8 fv-row" }
const _hoisted_77 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_78 = ["value"]
const _hoisted_79 = { class: "fv-plugins-message-container" }
const _hoisted_80 = { class: "fv-help-block" }
const _hoisted_81 = { class: "row mb-6" }
const _hoisted_82 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_83 = { class: "required" }
const _hoisted_84 = { class: "col-lg-8 fv-row" }
const _hoisted_85 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_86 = ["value"]
const _hoisted_87 = { class: "fv-plugins-message-container" }
const _hoisted_88 = { class: "fv-help-block" }
const _hoisted_89 = { class: "row mb-6" }
const _hoisted_90 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_91 = { class: "required" }
const _hoisted_92 = { class: "col-lg-8 fv-row" }
const _hoisted_93 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_94 = ["value"]
const _hoisted_95 = { class: "fv-plugins-message-container" }
const _hoisted_96 = { class: "fv-help-block" }
const _hoisted_97 = { class: "row mb-6" }
const _hoisted_98 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_99 = { class: "required" }
const _hoisted_100 = { class: "col-lg-8 fv-row" }
const _hoisted_101 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_102 = ["value"]
const _hoisted_103 = { class: "fv-plugins-message-container" }
const _hoisted_104 = { class: "fv-help-block" }
const _hoisted_105 = { class: "row mb-6" }
const _hoisted_106 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_107 = { class: "required" }
const _hoisted_108 = { class: "col-lg-8 fv-row" }
const _hoisted_109 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_110 = ["value"]
const _hoisted_111 = { class: "fv-plugins-message-container" }
const _hoisted_112 = { class: "fv-help-block" }
const _hoisted_113 = { class: "row mb-6" }
const _hoisted_114 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_115 = { class: "col-lg-8 fv-row" }
const _hoisted_116 = { class: "row mb-6" }
const _hoisted_117 = { class: "col-lg-4 col-form-label fw-bold fs-6 required" }
const _hoisted_118 = { class: "col-lg-8 fv-row" }
const _hoisted_119 = { class: "fv-plugins-message-container" }
const _hoisted_120 = { class: "fv-help-block" }
const _hoisted_121 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_122 = { class: "col-lg-4 col-form-label fw-bold fs-6 required" }
const _hoisted_123 = { class: "col-lg-8 fv-row" }
const _hoisted_124 = { class: "fv-plugins-message-container" }
const _hoisted_125 = { class: "fv-help-block" }
const _hoisted_126 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_127 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_128 = { class: "indicator-label" }
const _hoisted_129 = { class: "indicator-progress" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_SearchField = _resolveComponent("SearchField")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Attachment = _resolveComponent("Attachment")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('update', 'groomer'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateHorses')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitUpdate,
              "validation-schema": _ctx.validationSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('nameEn')), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nameEn",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('nameEn'),
                        modelValue: _ctx.horse.nameEn,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.horse.nameEn) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "nameEn" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('nameAr')), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nameAr",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('nameAr'),
                        modelValue: _ctx.horse.nameAr,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.horse.nameAr) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "nameAr" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('chipNumber')), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "chipNumber",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('chipNumber'),
                        modelValue: _ctx.horse.chipNumber,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.horse.chipNumber) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.translate('dateOfBirth')), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_Field, {
                        type: "date",
                        name: "dateOfBirth",
                        class: "form-control form-control-lg form-control-solid",
                        autocomplete: "off",
                        value: new Date(_ctx.horse.dateOfBirth).toISOString().substr(0, 10),
                        modelValue: _ctx.horse.dateOfBirth,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.horse.dateOfBirth) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DatePicker, {
                            id: "dateOfBirth",
                            class: "form-control form-control-lg form-control-solid",
                            modelValue: _ctx.horse.dateOfBirth,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.horse.dateOfBirth) = $event)),
                            placeholder: _ctx.translate('dd/mm/yyyy'),
                            fieldId: "dateOfBirth",
                            "today-only": true
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["value", "modelValue"]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_ErrorMessage, { name: "dateOfBirth" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.translate('joiningDate')), 1),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_Field, {
                        type: "date",
                        name: "joiningDate",
                        class: "form-control form-control-lg form-control-solid",
                        autocomplete: "off",
                        value: 
                  new Date(_ctx.horse.joiningDate).toISOString().substr(0, 10) || ''
                ,
                        modelValue: _ctx.horse.joiningDate,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.horse.joiningDate) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DatePicker, {
                            id: "joiningDate",
                            class: "form-control form-control-lg form-control-solid",
                            modelValue: _ctx.horse.joiningDate,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.horse.joiningDate) = $event)),
                            placeholder: _ctx.translate('dd/mm/yyyy'),
                            fieldId: "joiningDate",
                            "today-only": true
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["value", "modelValue"]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_ErrorMessage, { name: "joiningDate" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.translate('Passport')), 1),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "passport",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Passport'),
                        modelValue: _ctx.horse.passport,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.horse.passport) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_ErrorMessage, { name: "passport" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.translate('Dam')), 1),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "dam",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Dam'),
                        modelValue: _ctx.horse.dam,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.horse.dam) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.translate('Sire')), 1),
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "sire",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Sire'),
                        modelValue: _ctx.horse.sire,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.horse.sire) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.translate('classLimitPerDay')), 1),
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "classLimityPerDay",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('classLimitPerDay'),
                        modelValue: _ctx.horse.classLimitPerDay,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.horse.classLimitPerDay) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_ErrorMessage, { name: "classLimityPerDay" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("label", _hoisted_47, [
                      _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.translate('status')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "statusId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.horse.statusId,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.horse.statusId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_50, _toDisplayString(_ctx.translate('status')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (status) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: status.id,
                              value: status.id
                            }, _toDisplayString(status.nameEn), 9, _hoisted_51))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_ErrorMessage, { name: "statusId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("label", _hoisted_55, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('nationality')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "nationalityId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.horse.nationalityId,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.horse.nationalityId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_57, _toDisplayString(_ctx.translate('status')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nationalityList, (nationality) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: nationality.id,
                              value: nationality.id
                            }, _toDisplayString(nationality.nameEn), 9, _hoisted_58))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("label", _hoisted_60, [
                      _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.translate('Gender')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "genderId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.horse.genderId,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.horse.genderId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_63, _toDisplayString(_ctx.translate('GenderId')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderList, (gender) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: gender.id,
                              value: gender.id
                            }, _toDisplayString(gender.nameEn), 9, _hoisted_64))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createVNode(_component_ErrorMessage, { name: "genderId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("label", _hoisted_68, [
                      _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.translate('Horse Location')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(_component_Field, {
                        name: "horseLocationId",
                        modelValue: _ctx.horse.horseLocationId,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.horse.horseLocationId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SearchField, {
                            modelValue: _ctx.horse.horseLocationId,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.horse.horseLocationId) = $event)),
                            options: _ctx.horseLocationList,
                            mode: "single",
                            label: _ctx.translate('Select Horse Location'),
                            className: "form-select-md",
                            trackBy: "nameEn"
                          }, null, 8, ["modelValue", "options", "label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createVNode(_component_ErrorMessage, { name: "horseLocationId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("label", _hoisted_74, [
                      _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.translate('passportType')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "passportTypeId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.horse.passportTypeId,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.horse.passportTypeId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_77, _toDisplayString(_ctx.translate('passportType')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passportTypeList, (passport) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: passport.id,
                              value: passport.id
                            }, _toDisplayString(passport.nameEn), 9, _hoisted_78))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _createVNode(_component_ErrorMessage, { name: "passportTypeId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("label", _hoisted_82, [
                      _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.translate('Category')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "categoryId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.horse.categoryId,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.horse.categoryId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_85, _toDisplayString(_ctx.translate('Category')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (category) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: category.id,
                              value: category.id
                            }, _toDisplayString(category.nameEn), 9, _hoisted_86))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _createVNode(_component_ErrorMessage, { name: "categoryId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("label", _hoisted_90, [
                      _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.translate('Breed')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "breedId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.horse.breedId,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.horse.breedId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_93, _toDisplayString(_ctx.translate('Breed')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breedList, (breed) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: breed.id,
                              value: breed.id
                            }, _toDisplayString(breed.nameEn), 9, _hoisted_94))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _createVNode(_component_ErrorMessage, { name: "breedId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("label", _hoisted_98, [
                      _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.translate('Color')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "colorId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.horse.colorId,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.horse.colorId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_101, _toDisplayString(_ctx.translate('color')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorList, (color) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: color.id,
                              value: color.id
                            }, _toDisplayString(color.nameEn), 9, _hoisted_102))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("div", _hoisted_104, [
                          _createVNode(_component_ErrorMessage, { name: "colorId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("label", _hoisted_106, [
                      _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.translate('Horse Type')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_108, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "typeId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.horse.typeId,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.horse.typeId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_109, _toDisplayString(_ctx.translate('Horse Type')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.horseTypeList, (type) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: type.id,
                              value: type.id
                            }, _toDisplayString(type.nameEn), 9, _hoisted_110))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_111, [
                        _createElementVNode("div", _hoisted_112, [
                          _createVNode(_component_ErrorMessage, { name: "typeId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.translate('workCapacity')), 1),
                    _createElementVNode("div", _hoisted_115, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "workCapacity",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('workCapacity'),
                        value: "",
                        modelValue: _ctx.horse.workCapacity,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.horse.workCapacity) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_116, [
                    _createElementVNode("label", _hoisted_117, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('Owner')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _createVNode(_component_Field, {
                        name: "customerId",
                        modelValue: _ctx.horse.customerId,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.horse.customerId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SearchField, {
                            modelValue: _ctx.horse.customerId,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.horse.customerId) = $event)),
                            options: _ctx.customerList,
                            mode: "single",
                            label: _ctx.translate('Select Customer'),
                            className: "form-select-md"
                          }, null, 8, ["modelValue", "options", "label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _createVNode(_component_ErrorMessage, { name: "customerId" })
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.isHorseKRCPrivate || _ctx.isHorsePrivate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                        _createElementVNode("label", _hoisted_122, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.translate('Riders')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_123, [
                          _createVNode(_component_Field, { name: "ridersId" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Multiselect, {
                                mode: "tags",
                                "close-on-select": false,
                                requierd: false,
                                label: "name",
                                trackBy: "name",
                                searchable: true,
                                canDeselect: false,
                                placeholder: _ctx.translate('Select riders'),
                                valueProp: "id",
                                options: _ctx.customerList,
                                noResultsText: _ctx.translate('noResultsFound'),
                                "allow-empty": false,
                                required: true,
                                modelValue: _ctx.ridersId,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.ridersId) = $event))
                              }, null, 8, ["placeholder", "options", "noResultsText", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_124, [
                            _createElementVNode("div", _hoisted_125, [
                              _createVNode(_component_ErrorMessage, { name: "ridersId" })
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-white btn-active-light-primary me-2",
                    onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  (_ctx.can('update', 'groomer'))
                    ? (_openBlock(), _createElementBlock("button", _hoisted_127, [
                        _createElementVNode("span", _hoisted_128, _toDisplayString(_ctx.translate('saveChanges')), 1),
                        _createElementVNode("span", _hoisted_129, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_130
                        ])
                      ], 512))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Attachment, {
      attachments: _ctx.attachmentsObj,
      onSubmitCreate: _ctx.onSubmitUpdateAttachment,
      onDelete: _ctx.deleteAttachment
    }, null, 8, ["attachments", "onSubmitCreate", "onDelete"])
  ], 64))
}